import './Projects.css';

const Projects = () => {
    return (
        <div className="projects-container">
            <h2>Cool Stuff</h2>

            <div className="projects-wrapper">
                <div className="project">
                    <h3>
                        <a href="https://jsql.vercel.app" target="_blank" rel="noopener noreferrer">jsql</a>
                    </h3>
                    <p>
                        It's a SQL-like engine that lets you query JSON. Ever wanted to find specific objects matching a constraint in a giant JSON? Just query it like you would do in SQL.
                        <br />
                    </p>
                </div>

                <div className="project">
                    <h3>
                        <a href="https://github.com/rzinak/core-rss" target="_blank" rel="noopener noreferrer">Core RSS</a>
                    </h3>
                    <p>
                        An RSS feed reader that lets you follow your favorite blogs directly from the terminal.<br />
                    </p>
                </div>

                <div className="project">
                    <h3>
                        <a href="https://github.com/rzinak/oblivion" target="_blank" rel="noopener noreferrer">Oblivion</a>
                    </h3>
                    <p>
                        Oblivion is a lightweight dependency injection framework to manage dependencies in Java. It's still in progress but it's unlikely to be finished, only did this to understand more in depth how classes were 'injected'... Last thing I did there was implementing support for AOP, maybe one day I finish it
                    </p>
                </div>

                <div className="project">
                    <h3>
                        <a href="https://github.com/rzinak/chip8" target="_blank" rel="noopener noreferrer">CHIP-8 Emulator</a>
                    </h3>
                    <p>
                        A CHIP-8 emulator, that you can run in the browser. I used <a href="https://tobiasvl.github.io/blog/write-a-chip-8-emulator/" target="_blank" rel="noopener noreferrer">this</a> as a reference.<br />
                    </p>
                </div>
            </div>

            <div className="projects-more">
                <button onClick={() => window.open("https://github.com/rzinak", '_blank')}>More</button>
            </div>
        </div>
    );
}

export default Projects;
